import React from 'react';
import PropTypes from 'prop-types';
import ColorSF2 from '../../styles/common/ColorSF2';

const PlusSVG = ({ color = ColorSF2.black, size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    viewBox="0 0 256 256"
  >
    <path d="M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z" />
  </svg>
);

PlusSVG.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

PlusSVG.defaultProps = {
  color: ColorSF2.black,
  size: 24,
};

export default PlusSVG;
